module.exports = "/cyber/_next/static/images/steam-hero-bg-d2d26b9a6a79204d9e55fa3b506fdeda.jpg";